import { __assign } from "tslib";
import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../PnmacDatePicker.styles.js';
import { MobileDatePicker, LocalizationProvider } from "@material-ui/pickers";
import MomentUtils from '@material-ui/pickers/adapter/moment';
import TextField from '@material-ui/core/TextField';
var PnmacDatePicker = function (allprops) {
  return /*#__PURE__*/React.createElement(LocalizationProvider, {
    dateAdapter: MomentUtils
  }, /*#__PURE__*/React.createElement(MobileDatePicker, __assign({
    renderInput: allprops.renderInput,
    inputFormat: allprops.inputFormat,
    shouldDisableDate: allprops.shouldDisableDate,
    style: allprops.style,
    value: allprops.value,
    onChange: allprops.onChange,
    InputAdornmentProps: allprops.InputAdornmentProps,
    animateYearScrolling: allprops.animateYearScrolling,
    openTo: allprops.openTo,
    views: allprops.views,
    disableFuture: allprops.disableFuture,
    open: allprops.open,
    onClose: allprops.onClose
  }, allprops)));
};
PnmacDatePicker.propTypes = {};
export default PnmacDatePicker;